/**
 * URL baza e API – në browser përdor origjinën e faqes (http ose https)
 * që login dhe të gjitha thirrjet të funksionojnë pa konfigurim SSL nëse faqja hapet me http.
 */
export const BACKEND_URL =
  typeof window !== 'undefined' && window.location && window.location.origin
    ? window.location.origin
    : (process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000');

/**
 * URL e faqes së alarmeve /me/notifications.
 * Vendos REACT_APP_NOTIFICATIONS_URL (p.sh. https://toni.dioiot.com/me/notifications) nëse app-i është në origjine tjetër.
 * Përndryshe përdoret i njëjti host + /me/notifications.
 */
export function getNotificationsPageUrl() {
  const v = process.env.REACT_APP_NOTIFICATIONS_URL;
  if (v != null && String(v).trim() !== '') {
    return String(v).trim();
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/me/notifications`;
  }
  return '/me/notifications';
}

/** Përdor <Link> nëse i njëjti origjinë, përndryshe <a> për domain të jashtme. */
export function getNotificationsPageResolved() {
  const href = getNotificationsPageUrl();
  if (typeof window === 'undefined') {
    return { kind: 'link', to: '/me/notifications' };
  }
  if (href.startsWith('http://') || href.startsWith('https://')) {
    try {
      const u = new URL(href);
      if (u.origin === window.location.origin) {
        return { kind: 'link', to: `${u.pathname}${u.search}${u.hash}` };
      }
      return { kind: 'a', href, external: u.origin !== window.location.origin };
    } catch {
      return { kind: 'a', href, external: true };
    }
  }
  return { kind: 'link', to: href.startsWith('/') ? href : `/${href}` };
}
